import { render, staticRenderFns } from "./QuickOrderPayment.vue?vue&type=template&id=22a7bb3c&scoped=true"
import script from "./QuickOrderPayment.vue?vue&type=script&lang=js"
export * from "./QuickOrderPayment.vue?vue&type=script&lang=js"
import style0 from "./QuickOrderPayment.vue?vue&type=style&index=0&id=22a7bb3c&prod&scoped=true&lang=postcss"
import style1 from "./QuickOrderPayment.vue?vue&type=style&index=1&id=22a7bb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7bb3c",
  null
  
)

export default component.exports